export default __webpack_public_path__ + "images/tl-503b7926732b784efbede0c1d6569df2.svg";